import OAuthCallback from '../../../components/OAuthCallback.jsx';

const Office365OAuthCallback = ({}) => {
    return <OAuthCallback route="/api/calendars/office365/oauth" />;
};

export default Office365OAuthCallback;
